export interface CoverPresenceModel {
    id: number,
    codeMetric: number | null,
    name: string
}

export const coverPresenceModelInitial: CoverPresenceModel = {
    id: 0,
    codeMetric: 0,
    name: ''
};